/* Elford Lane – reveal-on-scroll with stagger */
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const SELECTOR = '.el-section-head, .el-tabs, .el-card, .el-cl__item, .el-cl__below, .el-tm__card, .el-sg__item, .el-ti__item, .el-fc .el-mt, .el-tp .el-mt';

if (!reduce && 'IntersectionObserver' in window) {
  document.documentElement.classList.add('el-motion');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

  const setup = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.dataset.elRev) return;
      el.dataset.elRev = '1';
      const item = el.closest('.el-track > *, .el-ti__grid > *') || el;
      const siblings = item.parentElement ? [...item.parentElement.children] : [item];
      const idx = Math.max(0, siblings.indexOf(item));
      el.style.setProperty('--el-delay', Math.min(idx, 5) * 90 + 'ms');
      el.classList.add('el-reveal');
      io.observe(el);
    });
  };

  setup();
  // Cards added later (recommendations, tab switches, theme editor)
  new MutationObserver((list) => {
    for (const m of list) m.addedNodes.forEach((n) => { if (n.nodeType === 1) setup(n.parentElement || document); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (e) => setup(e.target));
  // Hidden tab panels: reveal immediately when shown
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-el-tab]')) return;
    requestAnimationFrame(() => document.querySelectorAll('[data-el-panel]:not([hidden]) .el-reveal:not(.is-in)').forEach((el) => {
      const r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in');
    }));
  });
}
